import { render, staticRenderFns } from "./Headlines.vue?vue&type=template&id=16ecdb51&scoped=true"
import script from "./Headlines.vue?vue&type=script&lang=js"
export * from "./Headlines.vue?vue&type=script&lang=js"
import style0 from "./Headlines.vue?vue&type=style&index=0&id=16ecdb51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ecdb51",
  null
  
)

export default component.exports